<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C2" :fill="fill">
      <path
        class="st1"
        d="M163.2,155.9c37.2,25.9,93.5-43.6,164.3-84.2c-13.6-4.8-28-8.4-43.5-10.1c-98.2-11-105.3,25-161,18.7
		C92.7,77,78,66.7,60.5,56.8l67.9-11.2V35L44.9,48.8c0,0,0,0,0,0L17,53.5v-4.9l19.2-3.2c-9.7-3.5-21.3-6.4-36.2-8v18.9v10.5v61.5
		C0,128.3,50.8,77.7,163.2,155.9z"
      />
      <polygon class="st1" points="0,289.6 225.9,252.2 225.9,233.7 0,271 	" />
      <polygon
        class="st1"
        points="520.6,108.7 462.1,118.4 462.1,118.8 430.7,124 303.2,145.1 303.2,144.7 253.6,152.9 253.6,167.6 
		462.9,133 483.2,129.6 562.5,116.5 562.5,101.8 	"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SportsCover_c2",
  props: ["fill"],
};
</script>
